import { handleApiCall } from "../api";

export const getCategory = () => handleApiCall("get", "category");

export const getByCategoryID = (categoryID) => handleApiCall("get", `/attributes/category/${categoryID}`);

export const getCategoryById = (categoryId) => handleApiCall("get", `category/${categoryId}`);

export const createCategory = (postPayload) => handleApiCall("post", "category/", postPayload, { headers: { "Content-Type": "multipart/form-data" } });

export const updateCategory = (categoryID, patchPayload) => handleApiCall("patch", `category/${categoryID}`, patchPayload, { headers: { "Content-Type": "multipart/form-data" } });

export const deleteCategory = (categoryID) => handleApiCall("delete", `category/${categoryID}`);

//Subcategory endpoints
export const getSubCategory = (categoryID) => handleApiCall("get", `product-categories`);

export const getSubCategoryById = (categoryID) => handleApiCall("get", `product-categories/${categoryID}`);

export const createSubCategory = (postPayload) => handleApiCall("post", "product-categories", postPayload, { headers: { "Content-Type": "multipart/form-data" } });

export const updateSubCategory = (subCategoryID, patchPayload) => handleApiCall("patch", `product-categories/${subCategoryID}`, patchPayload, { headers: { "Content-Type": "multipart/form-data" } });

export const deleteSubCategory = (subCategoryID) => handleApiCall("delete", `product-categories/${subCategoryID}`);
